import { Box, Typography } from "@mui/material";
import { T } from "react-translator-component";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import styles from "../pages/GreenCity/payments/styles";
import { colors } from "../common/colors";
import dayjs from "../util/dayjs";

interface TransactionDetailsProps {
  payment: any;
  isAdd: boolean;
}

const TransactionDetails: React.FC<TransactionDetailsProps>  = ({payment, isAdd}) => {
  const getPaymentTypeJp = (item: any) => {
    if (item.billing_cycle === "monthly" || item?.payment_type === "monthly") {
      return T("monthly_fee");
    } else if (item.billing_cycle === "yearly" || item?.payment_type === "annual" || item?.payment_type === "yearly") {
      return T("yearly_fee");
    } else if (item?.payment_type === "joining_fee") {
      return T("payment_joining_fee");
    } else if (item?.payment_type === "event_fee") {
      return T("group_user_payment_event_fee");
    } else if (item?.payment_type === "StorePayment") {
      return T("payment_store_payment");
    } else if (item?.payment_type === "reimbursement") {
      return T("payment_reimbursement");
    } else if (item?.payment_type === "other_fee") {
      return T("other");
    } else {
      return item?.payment_type;
    }
  };

  const getPayerOrPayeeName = () => {
    return isAdd ?
      payment?.payer.nickname || payment?.payer.name :
      payment?.payee.nickname || payment?.payee?.name
  }

  const getColor = (isBorderLine: boolean) => {
    if (isAdd) {
      return isBorderLine ? colors.farm_green500 : colors.farm_green100
    } else {
      return isBorderLine ? colors.farm_red600 : colors.farm_red10
    }
  }

  const DetailRow = ({values}: any) => {
    return (<>
      <Box sx={styles.separator2} />
      <Box sx={styles.row}>
        <Typography sx={styles.boxLeft}>{values[0]}</Typography>
        <Typography sx={styles.boxRight}>{values[1]}</Typography>
      </Box>
    </>)
  }

  const DetailRowAmount = () => {
    return (<>
      <Box sx={styles.separator2} />
      <Box sx={styles.row}>
        <Typography sx={styles.boxLeft}>{T("payment_payment_amount")}</Typography>
        <Typography sx={{ ...styles.boxRight, color: getColor(true), fontFamily: "mplus-1c-bold" }}>{`¥ ${payment.formatted_amount}`}</Typography>
      </Box>
    </>)
  }

  return (
    <Box sx={{ ...styles.boxContainer, borderColor: getColor(true) }}>
      <Box sx={{ ...styles.row, backgroundColor: getColor(false) }}>
        <Typography sx={{ padding: "5px", flex: 1 }}>{dayjs(payment?.created_at).format("YYYY年MM月DD日HH:mm")}</Typography>
        {isAdd ?
          <AddCircleOutlineIcon sx={{ ...styles.addIcon, color: getColor(true) }} /> :
          <RemoveCircleOutlineOutlinedIcon sx={{ ...styles.addIcon, color: getColor(true) }} />
        }
      </Box>
      {payment.reimbursement ? (<>
        <DetailRow values={[T("payment_history_type"), getPaymentTypeJp(payment)]}/>
        <DetailRow values={[isAdd ? T("payment_payer") : T("payment_payee"), getPayerOrPayeeName()]}/>
        <DetailRow values={[T("payment_payment_date"), dayjs(payment.reimbursement?.payment_date).format("YYYY年MM月DD日（dd）")]}/>
        <DetailRow values={[T("payment_payee_nickname"), payment?.payee?.nickname || payment?.payee?.name]}/>
        <DetailRowAmount />
        <DetailRow values={[T("payment_method"), T("payment_mabuku_pay")]}/>
        <DetailRow values={[T("payment_details"), payment?.payment_details]}/>
        <DetailRow values={[T("reimbursement_id"), payment.reimbursement.id]}/>
        <DetailRow values={[T("payment_transaction_id"), payment?.transaction_id]}/>
      </>) : (<>
        {isAdd ?
          <DetailRow values={[T("payment_payer"), payment?.payer.nickname || payment?.payer.name]}/> :
          <DetailRow values={[T("payment_history_type"), getPaymentTypeJp(payment)]}/>
        }
        {isAdd ?
          <DetailRowAmount /> :
          <DetailRow values={[T("payment_payee_nickname"), payment?.payee.nickname || payment?.payee?.name]}/>
        }
        {isAdd ?
          <DetailRow values={[T("payment_history_type"), getPaymentTypeJp(payment)]}/> :
          <DetailRowAmount />
        }
        {isAdd ?
          <DetailRow values={[T("payment_transaction_id"), payment?.transaction_id]}/> :
          <DetailRow values={[T("payment_details"), payment?.payment_details]}/>
        }
        {!isAdd && (
          <DetailRow values={[T("payment_transaction_id"), payment?.transaction_id]}/>
        )}
      </>)}
    </Box>
  );
}

export default TransactionDetails;